import { Row, Col, FormGroup } from 'react-bootstrap';
import React, { Component } from 'react';
import FormularioPadrao from '../FormularioPadrao';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import IntegerInput from '../../components/IntegerInput';
import { buildQueryString, updateState } from '../../utils/Functions';
import SubCadastro from '../../components/SubCadastro';
import Select from '../../components/Select';
import {
   getTiposDeUnidadeDeLimiteSOPFrequencia,
   getTiposDeUnidadeDeLimiteSOPSaturacao,
   getTiposDeTestesSOP,
   getTiposDeTransmissaoSOP,
   getTiposDeAmplitudeSOP,
} from '../Descricoes';
import { showError } from '../../components/Messages';
import { Link } from 'react-router-dom';
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../components/IconButton';
import SequenciaSOPController from '../../controllers/Sequencias/SequenciaSOPController';
import TipoDeEnsaioView from './TipoDeEnsaioView';
import Button from '../../components/Button';
import CheckListView from '../Empresa/CheckListView';

const TIPO_DE_TESTE = {
   sopSaturacao: 0,
   sopFrquencia: 1,
};

export default class SequenciaSOPView extends Component {
   constructor(props) {
      super(props);
      this.state = {};
      this.controller = new SequenciaSOPController(this);
   }

   setUltimoItemCriado = (item) => {
      updateState(this, (state) => {
         state.ultimoItemCriado = {};
         state.ultimoItemCriado.numero = item.numero;
         state.ultimoItemCriado.tipoDeTeste = item.tipoDeTeste;
         state.ultimoItemCriado.limiteSuperior = item.limiteSuperior;
         state.ultimoItemCriado.limiteInferior = item.limiteInferior;
         state.ultimoItemCriado.unidadeLimites = item.unidadeLimites;
         state.ultimoItemCriado.spO2_NivelDePerfusao = item.spO2_NivelDePerfusao;
         state.ultimoItemCriado.spO2_CorLarguraDedo = item.spO2_CorLarguraDedo;
         state.ultimoItemCriado.spO2_Saturacao = item.spO2_Saturacao;
         state.ultimoItemCriado.spO2_Freq = item.spO2_Freq;
      });
   };

   getDescricaoDoTipoDeTesteSOP = (id) => {
      let result = getTiposDeTestesSOP(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDaUnidadeDesvioSOPFrequencia = (id) => {
      let result = getTiposDeUnidadeDeLimiteSOPFrequencia(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDaUnidadeDesvioSOPSaturacao = (id) => {
      let result = getTiposDeUnidadeDeLimiteSOPSaturacao(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   renderizarFormulario = () => {
      let lang = this.props.lang;
      return (
         <React.Fragment>
            <Row>
               <Col sm={2} md={2} lg={2}>
                  <FormGroup>
                     <Label>{lang.codigo}</Label>
                     <TextInput readOnly defaultValue={this.state.itemSelecionado.id} />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{lang.sequencia.nome}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.nome}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.nome = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>
               <Col sm={3} md={3} lg={3}>
                  <FormGroup>
                     <Label>{lang.sequencia.situacao}</Label>
                     <Select
                        name='situacao'
                        defaultValue={this.state.itemSelecionado.situacao && this.state.itemSelecionado.situacao.id}
                        options={[
                           { id: 1, descricao: lang.sequencia.ativa },
                           { id: 2, descricao: lang.sequencia.inativa },
                        ]}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.descricao}
                        onSelect={(i) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.situacao = i;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <br />

            <SubCadastro
               titulo={lang.sequencia.tiposDeEnsaio} modal={true}
               exibirTitulos={false}
               itens={this.state.itemSelecionado.tiposDeEnsaio}
               lang={lang}
               novo={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.tipoDeEnsaioSelecionado = {
                           tipoDeEnsaio: null,
                        };
                     }).then(() => resolve());
                  });
               }}
               inserir={() => {
                  return new Promise((resolve, reject) => {
                     if (!this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio) {
                        showError(lang.sequencia.mensagens.informeOTipoDeEnsaio);
                        reject();
                        return false;
                     }

                     updateState(this, (state) => {
                        if (!state.itemSelecionado.tiposDeEnsaio) {
                           state.itemSelecionado.tiposDeEnsaio = [];
                        }
                        state.itemSelecionado.tiposDeEnsaio.push({
                           tipoDeEnsaio: this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio,
                        });
                     }).then(() => resolve());
                  });
               }}
               cancelar={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.tipoDeEnsaioSelecionado = null;
                     }).then(() => resolve());
                  });
               }}
               excluir={(index) => {
                  updateState(this, (state) => {
                     state.itemSelecionado.tiposDeEnsaio.splice(index, 1);
                  });
               }}
               colunas={() => {
                  return [{ titulo: 'Nome', width: '100%', className: null }];
               }}
               linha={(item) => {
                  return [item.tipoDeEnsaio.nome];
               }}
               formulario={() => {
                  return (
                     <Row>
                        <Col>
                           <Label>{lang.sequencia.tipoDeEnsaio}</Label>
                           <Select
                              name={'tipoDeEnsaio'} modal={true}
                              defaultValue={this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio}
                              getKeyValue={(i) => i.id}
                              getDescription={(i) => (i && i.nome ? i.nome.toUpperCase() : null)}
                              onSelect={(i) => {
                                 updateState(this, (state) => {
                                    state.tipoDeEnsaioSelecionado.tipoDeEnsaio = i;
                                 });
                              }}
                              formularioPadrao={(select) => {
                                 return (
                                    <TipoDeEnsaioView api={this.props.api} select={select} lang={this.props.lang} />
                                 );
                              }}
                              asws={true}
                              noDropDown={true}
                              readOnlyColor='#ffff'
                              getFilterUrl={(text) =>
                                 '/tipodeensaio' + buildQueryString(2, null, 'id', { Searchable: text })
                              }
                           />
                        </Col>
                     </Row>
                  );
               }}
            />

            <br />
            {!this.state.itemSelecionado.sequenciaNeos && (
               <SubCadastro
                  titulo={lang.sequencia.checkList} modal={true}
                  exibirTitulos={false}
                  itens={this.state.itemSelecionado.checkList}
                  lang={lang}
                  novo={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.checkListSelecionado = {
                              checkList: null,
                           };
                        }).then(() => resolve());
                     });
                  }}
                  inserir={() => {
                     return new Promise((resolve, reject) => {
                        if (!this.state.checkListSelecionado.checkList) {
                           showError(lang.sequencia.mensagens.informeOCheckList);
                           reject();
                           return false;
                        }

                        updateState(this, (state) => {
                           if (!state.itemSelecionado.checkList) {
                              state.itemSelecionado.checkList = [];
                           }
                           state.itemSelecionado.checkList.push({
                              checkList: this.state.checkListSelecionado.checkList,
                           });
                        }).then(() => resolve());
                     });
                  }}
                  cancelar={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.checkListSelecionado = null;
                        }).then(() => resolve());
                     });
                  }}
                  excluir={(index) => {
                     updateState(this, (state) => {
                        state.itemSelecionado.checkList.splice(index, 1);
                     });
                  }}
                  colunas={() => {
                     return [{ titulo: lang.sequencia.checkList, width: '100%', className: null }];
                  }}
                  linha={(item) => {
                     return [item.checkList.descricao];
                  }}
                  formulario={() => {
                     return (
                        <Row>
                           <Col>
                              <Label>{lang.sequencia.checkList}</Label>
                              <Select
                                 name={'checkList'}  modal={true}
                                 defaultValue={this.state.checkListSelecionado.checkList}
                                 getKeyValue={(i) => i.id}
                                 getDescription={(i) => i.descricao}
                                 onSelect={(i) => {
                                    updateState(this, (state) => {
                                       state.checkListSelecionado.checkList = i;
                                    });
                                 }}
                                 formularioPadrao={(select) => {
                                    return (
                                       <CheckListView api={this.props.api} select={select} lang={this.props.lang} />
                                    );
                                 }}
                                 noDropDown={true}
                                 readOnlyColor='#ffff'
                                 getFilterUrl={(text) =>
                                    '/checklist' + buildQueryString(2, null, 'descricao', { Searchable: text })
                                 }
                              />
                           </Col>
                        </Row>
                     );
                  }}
               />
            )}

            <br />

            <SubCadastro
               titulo={lang.sequencia.testes}
               exibirTitulos={true}
               itens={this.state.itemSelecionado.itens}
               gradeSempreVisivel={true}
               lang={lang}
               tituloDoBotaoCancelar={lang.sequencia.finalizarCadastroDeTeste}
               novo={
                  !this.state.itemSelecionado.sequenciaNeos ||
                  (this.state.itemSelecionado.sequenciaNeos && this.props.sessionManager.isUsuarioNeos())
                     ? () => {
                          return new Promise((resolve) => {
                             let maiorNumero = 0;
                             if (this.state.itemSelecionado.itens) {
                                this.state.itemSelecionado.itens.map((i, index) => {
                                   if (i.numero > maiorNumero) {
                                      maiorNumero = i.numero;
                                   }
                                   return true;
                                });
                             }
                             maiorNumero++;
                             updateState(this, (state) => {
                              state.configuracaoSelecionada = null;
                              let configuracaoSelecionada = { tipoDeTeste: 0 };
                              this.setValoresDefault(configuracaoSelecionada);
                              configuracaoSelecionada.numero = maiorNumero;
                              state.configuracaoSelecionada = configuracaoSelecionada;
                             }).then(() => resolve());
                          });
                       }
                     : null
               }
               inserir={() => {
                  return new Promise((resolve, reject) => {
                     // if (!this.state.configuracaoSelecionada.repeticoes) {
                     //    showError(lang.sequencia.informeONumeroDeRepeticoes);
                     //    reject();
                     //    return false;
                     // }

                     if (this.state.configuracaoSelecionada.limiteSuperior === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeOLimiteSuperior);
                        reject();
                        return false;
                     }
                     if (this.state.configuracaoSelecionada.limiteInferior === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeOLimiteInferior);
                        reject();
                        return false;
                     }
                     if (this.state.configuracaoSelecionada.spO2_Saturacao === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeASaturacao);
                        reject();
                        return false;
                     }
                     if (this.state.configuracaoSelecionada.spO2_Freq === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeAFrequencia);
                        reject();
                        return false;
                     }

                     updateState(this, (state) => {
                        if (!state.itemSelecionado.itens) {
                           state.itemSelecionado.itens = [];
                        }

                        let item = {
                           numero: this.state.configuracaoSelecionada.numero,
                           repeticoes: 1,
                           tipoDeTeste: this.state.configuracaoSelecionada.tipoDeTeste,
                           limiteSuperior: this.state.configuracaoSelecionada.limiteSuperior,
                           limiteInferior: this.state.configuracaoSelecionada.limiteInferior,
                           unidadeLimites: this.state.configuracaoSelecionada.unidadeLimites,
                           spO2_Freq: this.state.configuracaoSelecionada.spO2_Freq,
                           spO2_Saturacao: this.state.configuracaoSelecionada.spO2_Saturacao,
                           spO2_NivelDePerfusao: this.state.configuracaoSelecionada.spO2_NivelDePerfusao,
                           spO2_CorLarguraDedo: this.state.configuracaoSelecionada.spO2_CorLarguraDedo,
                        };

                        state.itemSelecionado.itens.push(item);
                        this.setUltimoItemCriado(item);
                     }).then(() => resolve());
                  });
               }}
               aposSalvar={this.aposSalvar}
               selecionarParaAlteracao={(index) => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = JSON.parse(JSON.stringify(state.itemSelecionado.itens[index]));
                     }).then(() => resolve());
                  });
               }}
               alterar={(index) => {
                  return new Promise((resolve, reject) => {
                     // if (!this.state.configuracaoSelecionada.repeticoes) {
                     //    showError(lang.sequencia.informeONumeroDeRepeticoes);
                     //    reject();
                     //    return false;
                     // }

                     if (this.state.configuracaoSelecionada.limiteSuperior === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeOLimiteSuperior);
                        reject();
                        return false;
                     }
                     if (this.state.configuracaoSelecionada.limiteInferior === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeOLimiteInferior);
                        reject();
                        return false;
                     }
                     if (this.state.configuracaoSelecionada.spO2_Saturacao === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeASaturacao);
                        reject();
                        return false;
                     }
                     if (this.state.configuracaoSelecionada.spO2_Freq === 0) {
                        showError(lang.cadastroDeSequenciaSOP.mensagens.informeAFrequencia);
                        reject();
                        return false;
                     }

                     updateState(this, (state) => {
                        state.itemSelecionado.itens[index].numero = this.state.configuracaoSelecionada.numero;
                        state.itemSelecionado.itens[index].repeticoes = this.state.configuracaoSelecionada.repeticoes;
                        state.itemSelecionado.itens[index].tipoDeTeste = this.state.configuracaoSelecionada.tipoDeTeste;
                        state.itemSelecionado.itens[index].limiteSuperior =
                           this.state.configuracaoSelecionada.limiteSuperior;
                        state.itemSelecionado.itens[index].limiteInferior =
                           this.state.configuracaoSelecionada.limiteInferior;
                        state.itemSelecionado.itens[index].unidadeLimites =
                           this.state.configuracaoSelecionada.unidadeLimites;
                        state.itemSelecionado.itens[index].spO2_Freq = this.state.configuracaoSelecionada.spO2_Freq;
                        state.itemSelecionado.itens[index].spO2_Saturacao =
                           this.state.configuracaoSelecionada.spO2_Saturacao;
                        state.itemSelecionado.itens[index].spO2_NivelDePerfusao =
                           this.state.configuracaoSelecionada.spO2_NivelDePerfusao;
                        state.itemSelecionado.itens[index].spO2_CorLarguraDedo =
                           this.state.configuracaoSelecionada.spO2_CorLarguraDedo;
                        this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                     }).then(() => resolve());
                  });
               }}
               cancelar={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = null;
                     }).then(() => resolve());
                  });
               }}
               excluir={
                  !this.state.itemSelecionado.sequenciaNeos ||
                  (this.state.itemSelecionado.sequenciaNeos && this.props.sessionManager.isUsuarioNeos())
                     ? (index) => {
                          updateState(this, (state) => {
                             state.itemSelecionado.itens.splice(index, 1);
                             state.itemSelecionado.itens.map((i, index) => (i.numero = index + 1));
                          });
                       }
                     : null
               }
               colunas={() => {
                  return [
                     { titulo: 'Nº', width: '3%', className: null },
                     { titulo: 'Tipo de Teste', width: '17%', className: null },
                     { titulo: 'Valor de referência', width: '22%', className: null },
                     { titulo: 'Desvio máximo superior', width: '17%', className: null },
                     { titulo: 'Desvio máximo inferior', width: '16%', className: null },
                     { titulo: 'Unidade de desvio', width: '25%', className: null },
                  ];
               }}
               linha={(item) => {
                  return [
                     item.numero,
                     this.getDescricaoDoTipoDeTesteSOP(item.tipoDeTeste),
                     item.tipoDeTeste === 0 ? item.spO2_Saturacao + ' %' : item.spO2_Freq + ' BPM',
                     item.limiteSuperior,
                     item.limiteInferior,
                     item.tipoDeTeste === 0
                        ? this.getDescricaoDaUnidadeDesvioSOPSaturacao(item.unidadeLimites)
                        : this.getDescricaoDaUnidadeDesvioSOPFrequencia(item.unidadeLimites),
                  ];
               }}
               acoes={(subCadastro, index) => {
                  return (
                     <div style={{ display: 'table-cell', margin: 'auto', marginRight: 4, width: 25 }}>
                        <IconButton
                           title={lang.formularioPadrao.alterar}
                           style={{ fontSize: 23, marginBottom: -10 }}
                           cursor='pointer'
                           icon={faSortUp}
                           onClick={() => {
                              if (this.state.itemSelecionado.itens[index].numero > 1) {
                                 updateState(this, (state) => {
                                    state.itemSelecionado.itens[index - 1].numero =
                                       state.itemSelecionado.itens[index].numero;
                                    state.itemSelecionado.itens[index].numero =
                                       state.itemSelecionado.itens[index].numero - 1;
                                 }).then(() => {
                                    this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                                    this.aposSalvar(subCadastro, false, true);
                                 });
                              }
                           }}
                        />
                        <IconButton
                           title={lang.formularioPadrao.alterar}
                           style={{ fontSize: 23, marginTop: -10 }}
                           cursor='pointer'
                           icon={faSortDown}
                           onClick={() => {
                              if (
                                 this.state.itemSelecionado.itens[index].numero <
                                 this.state.itemSelecionado.itens.length
                              ) {
                                 updateState(this, (state) => {
                                    state.itemSelecionado.itens[index + 1].numero =
                                       state.itemSelecionado.itens[index].numero;
                                    state.itemSelecionado.itens[index].numero =
                                       state.itemSelecionado.itens[index].numero + 1;
                                 }).then(() => {
                                    this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                                    this.aposSalvar(subCadastro, false, true);
                                 });
                              }
                           }}
                        />
                     </div>
                  );
               }}
               formulario={() => {
                  return this.state.configuracaoSelecionada ? (
                     <div>
                        <Row>
                        <Col sm={2} md={2} lg={2}>
                              <FormGroup>
                                 <Label>{lang.sequencia.numero}</Label>
                                 <IntegerInput
                                    defaultValue={this.state.configuracaoSelecionada.numero}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.numero = e.floatValue;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           {/* <Col xs={2} md={2} xl={2}>
                              <FormGroup>
                                 <Label>{lang.sequencia.repeticoes}</Label>
                                 <IntegerInput
                                    // defaultValue={this.state.configuracaoSelecionada.repeticoes}
                                    defaultValue={1}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.repeticoes = e.floatValue;
                                       });
                                    }}
                                    readOnly={true}
                                 />
                              </FormGroup>
                           </Col> */}
                           <Col>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaSOP.tipoDeTeste}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.tipoDeTeste}
                                    options={getTiposDeTestesSOP(lang)}
                                    getKeyValue={(i) => i.id}
                                    allowEmpty={false}
                                    getDescription={(i) => i.descricao}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.tipoDeTeste = i.id;
                                          } else {
                                             state.configuracaoSelecionada.tipoDeTeste = 0;
                                          }
                                          let configuracaoSelecionada = state.configuracaoSelecionada;
                                          this.setValoresDefault(configuracaoSelecionada);
                                          state.configuracaoSelecionada = configuracaoSelecionada;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>

                           <Col xs={3} md={3} xl={3}>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaSOP.frequenciaBPM}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.spO2_Freq}
                                    options={[
                                       { id: 20, descricao: '20' },
                                       { id: 30, descricao: '30' },
                                       { id: 40, descricao: '40' },
                                       { id: 50, descricao: '50' },
                                       { id: 60, descricao: '60' },
                                       { id: 70, descricao: '70' },
                                       { id: 80, descricao: '80' },
                                       { id: 90, descricao: '90' },
                                       { id: 100, descricao: '100' },
                                       { id: 110, descricao: '110' },
                                       { id: 120, descricao: '120' },
                                       { id: 130, descricao: '130' },
                                       { id: 140, descricao: '140' },
                                       { id: 150, descricao: '150' },
                                       { id: 160, descricao: '160' },
                                       { id: 170, descricao: '170' },
                                       { id: 180, descricao: '180' },
                                       { id: 190, descricao: '190' },
                                       { id: 200, descricao: '200' },
                                       { id: 210, descricao: '210' },
                                       { id: 220, descricao: '220' },
                                       { id: 230, descricao: '230' },
                                       { id: 240, descricao: '240' },
                                       { id: 250, descricao: '250' },
                                       { id: 260, descricao: '260' },
                                       { id: 270, descricao: '270' },
                                       { id: 280, descricao: '280' },
                                       { id: 290, descricao: '290' },
                                       { id: 300, descricao: '300' },
                                    ]}
                                    getKeyValue={(i) => i.id}
                                    getDescription={(i) => i.descricao}
                                    allowEmpty={false}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.spO2_Freq = i.id;
                                          } else {
                                             state.configuracaoSelecionada.spO2_Freq = 0;
                                          }
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>

                           <Col xs={3} md={3} xl={3}>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaSOP.amplitude}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.spO2_NivelDePerfusao}
                                    options={getTiposDeAmplitudeSOP(lang)}
                                    getKeyValue={(i) => i.id}
                                    getDescription={(i) => i.descricao}
                                    allowEmpty={false}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.spO2_NivelDePerfusao = i.id;
                                          } else {
                                             state.configuracaoSelecionada.spO2_NivelDePerfusao = 0;
                                          }
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                        </Row>
                        <Row>
                           <Col xs={3} md={3} xl={3}>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaSOP.transmissao}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.spO2_CorLarguraDedo}
                                    options={getTiposDeTransmissaoSOP(lang)}
                                    getKeyValue={(i) => i.id}
                                    getDescription={(i) => i.descricao}
                                    allowEmpty={false}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.spO2_CorLarguraDedo = i.id;
                                          } else {
                                             state.configuracaoSelecionada.spO2_CorLarguraDedo = 0;
                                          }
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>

                           <Col xs={3} md={3} xl={3}>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaSOP.saturacao}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.spO2_Saturacao}
                                    options={[
                                       { id: 50, descricao: '50%' },
                                       { id: 51, descricao: '51%' },
                                       { id: 52, descricao: '52%' },
                                       { id: 53, descricao: '53%' },
                                       { id: 54, descricao: '54%' },
                                       { id: 55, descricao: '55%' },
                                       { id: 56, descricao: '56%' },
                                       { id: 57, descricao: '57%' },
                                       { id: 58, descricao: '58%' },
                                       { id: 59, descricao: '59%' },
                                       { id: 60, descricao: '60%' },
                                       { id: 61, descricao: '61%' },
                                       { id: 62, descricao: '62%' },
                                       { id: 63, descricao: '63%' },
                                       { id: 64, descricao: '64%' },
                                       { id: 65, descricao: '65%' },
                                       { id: 66, descricao: '66%' },
                                       { id: 67, descricao: '67%' },
                                       { id: 68, descricao: '68%' },
                                       { id: 69, descricao: '69%' },
                                       { id: 70, descricao: '70%' },
                                       { id: 71, descricao: '71%' },
                                       { id: 72, descricao: '72%' },
                                       { id: 73, descricao: '73%' },
                                       { id: 74, descricao: '74%' },
                                       { id: 75, descricao: '75%' },
                                       { id: 76, descricao: '76%' },
                                       { id: 77, descricao: '77%' },
                                       { id: 78, descricao: '78%' },
                                       { id: 79, descricao: '79%' },
                                       { id: 80, descricao: '80%' },
                                       { id: 81, descricao: '81%' },
                                       { id: 82, descricao: '82%' },
                                       { id: 83, descricao: '83%' },
                                       { id: 84, descricao: '84%' },
                                       { id: 85, descricao: '85%' },
                                       { id: 86, descricao: '86%' },
                                       { id: 87, descricao: '87%' },
                                       { id: 88, descricao: '88%' },
                                       { id: 89, descricao: '89%' },
                                       { id: 90, descricao: '90%' },
                                       { id: 91, descricao: '91%' },
                                       { id: 92, descricao: '92%' },
                                       { id: 93, descricao: '93%' },
                                       { id: 94, descricao: '94%' },
                                       { id: 95, descricao: '95%' },
                                       { id: 96, descricao: '96%' },
                                       { id: 97, descricao: '97%' },
                                       { id: 98, descricao: '98%' },
                                       { id: 99, descricao: '99%' },
                                       { id: 100, descricao: '100%' },
                                    ]}
                                    getKeyValue={(i) => i.id}
                                    getDescription={(i) => i.descricao}
                                    allowEmpty={false}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.spO2_Saturacao = i.id;
                                          } else {
                                             state.configuracaoSelecionada.spO2_Saturacao = 0;
                                          }
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                        </Row>
                        <Row>
                           <Col xs={3} md={3} xl={3}>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaSOP.desvioMaximoSuperior}</Label>
                                 <IntegerInput
                                    defaultValue={this.state.configuracaoSelecionada.limiteSuperior}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.limiteSuperior = e.value;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           <Col xs={3} md={3} xl={3}>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaSOP.desvioMaximoInferior}</Label>
                                 <IntegerInput
                                    defaultValue={this.state.configuracaoSelecionada.limiteInferior}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.limiteInferior = e.value;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           {this.state.configuracaoSelecionada.tipoDeTeste === 0 && (
                              <Col>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaSOP.unidadeDeLimite}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDeLimiteSOPSaturacao(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       acceptZero={true}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           )}
                           {this.state.configuracaoSelecionada.tipoDeTeste === 1 && (
                              <Col>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaSOP.unidadeDeLimite}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDeLimiteSOPFrequencia(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       acceptZero={true}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           )}
                        </Row>
                     </div>
                  ) : (
                     <div />
                  );
               }}
            />
            <br />
         </React.Fragment>
      );
   };

   renderizarAcoesDoFormulario = () => {
      return (
         <div>
            <Button
               text={this.props.lang.sequencia.duplicarSequencia}
               style={{ width: 200 }}
               onClick={() => {
                  let item = JSON.parse(JSON.stringify(this.state.itemSelecionado));
                  item.id = null;
                  if (item.itens != null) {
                     for (let i = 0; i < item.itens.length; i++) {
                        item.itens[i].id = null;
                     }
                  }
                  if (item.tiposDeEnsaio != null) {
                     for (let i = 0; i < item.tiposDeEnsaio.length; i++) {
                        item.tiposDeEnsaio[i].id = null;
                     }
                  }

                  updateState(this, (state) => {
                     state.incluindo = false;
                     state.alterando = false;
                     state.valorPadrao = item;
                  }).then(() => {
                     this.form.inserirClick();
                  });
               }}
            />
            <br />
         </div>
      );
   };

   aposSalvar = (subCadastro, inserindo, alterando) => {
      let ordem = this.state.ultimoItemCriado.numero;
      updateState(this, (state) => {
         state.itemSelecionado.itens.sort((i, j) => {
            let result = i.numero < j.numero ? -1 : i.numero > j.numero ? 1 : 0;
            if (j.numero === ordem && i.numero === ordem) {
               result = -1;
            }
            return result;
         });
         state.itemSelecionado.itens.map((i, index) => (i.numero = index + 1));
      });
      if (inserindo) {
         subCadastro.novo();
      }
   };

   setValoresDefault = (item) => {
      let padrao = null;

      if (this.state.ultimoItemCriado && !this.state.configuracaoSelecionada) {
         padrao = this.state.ultimoItemCriado;
      } else if (item !== null) {
         if (item.tipoDeTeste === TIPO_DE_TESTE.sopSaturacao) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               limiteSuperior: 10,
               limiteInferior: 10,
               unidadeLimites: 0,
               spO2_Freq: 60,
               spO2_Saturacao: 98,
               spO2_NivelDePerfusao: 2,
               spO2_CorLarguraDedo: 0,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.sopFrequencia) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               limiteSuperior: 10,
               limiteInferior: 10,
               unidadeLimites: 0,
               spO2_Freq: 60,
               spO2_Saturacao: 98,
               spO2_NivelDePerfusao: 2,
               spO2_CorLarguraDedo: 0,
            };
         }
      } else {
         padrao = {
            tipoDeTeste: 0,
         };
      }

      if (padrao) {
         item.repeticoes = 1;
         item.tipoDeTeste = padrao.tipoDeTeste;
         item.limiteSuperior = padrao.limiteSuperior;
         item.limiteInferior = padrao.limiteInferior;
         item.unidadeLimites = padrao.unidadeLimites;
         item.spO2_Freq = padrao.spO2_Freq;
         item.spO2_Saturacao = padrao.spO2_Saturacao;
         item.spO2_NivelDePerfusao = padrao.spO2_NivelDePerfusao;
         item.spO2_CorLarguraDedo = padrao.spO2_CorLarguraDedo;
      }
   };

   render() {
      return (
         <FormularioPadrao
            titulo={
               <div>
                  <Link
                     to={'/sequencia'}
                     replace={true}
                     style={{
                        textDecoration: 'none',
                        padding: '5px 5px 5px 0px',

                        cursor: 'pointer',
                     }}
                  >
                     <span style={{ opacity: 0.7 }}>{this.props.lang.sequencias}</span>                     
                  </Link>
                  <span>{' - '}</span>
                  <span>{this.props.lang.cadastroDeSequenciaSOP.titulo}</span>
               </div>
            }
            url={'/sequenciasop'}
            fastUrl={'/sequenciasop/fast'}
            api={this.props.api}
            lang={this.props.lang}
            ordenacaoPadrao={'nome'}
            permissoes={[1281, 1282, 1283, 1284]}
            getFiltro={this.controller.getFiltro}
            getTitulosDaTabela={this.controller.getTitulosDaTabela}
            getDadosDaTabela={this.controller.getDadosDaTabela}
            renderizarFormulario={this.renderizarFormulario}
            renderizarAcoesDoFormulario={this.renderizarAcoesDoFormulario}
            getObjetoDeDados={this.controller.getObjetoDeDados}
            antesDeInserir={this.controller.antesDeInserir}
            antesDeEditar={this.controller.antesDeEditar}
            antesDeSalvar={this.controller.antesDeSalvar}
            antesDeExcluir={this.controller.antesDeExcluir}
            getFormState={() => {
               return this.state;
            }}
            ref={(c) => (this.form = c)}
            definirValoresPadrao={(item) => {
               return this.state.valorPadrao ? this.state.valorPadrao : item;
            }}
            setFormState={(state, callback) => {
               return new Promise((resolve) => {
                  this.setState(state, () => {
                     resolve();
                     if (callback) {
                        callback();
                     }
                  });
               });
            }}
            select={this.props.select}
            itemVazio={{
               situacao: { id: 1 },
               acessos: [],
            }}
         />
      );
   }
}
